module.exports = __webpack_public_path__ + "static/media/home13.349b7aa8.jpg";